<template>
   <div class="header-bar">
     <div class="header">
          <img class="logo" @click="toIndex" src="../assets/images/nav/logo.png" alt="">
        <div class="nav-btns flex-items" v-if="token">
          <div @click="navTo('/')" :class="$route.path=='/'||$route.path =='/toubiao'?'active':''">
            报名
          </div>
          <div @click="navTo('/tbList')" :class="$route.path=='/tbList'||$route.path=='/detailsInfo'||$route.path=='/editTb'?'active':''">报名记录</div>
<!--          <div @click="navTo('/userInfo')">个人中心</div>-->
        </div>
       <div class="login-btns">
<!--         <div class="msg" v-if="token" @click="navTo('/userMsg')">-->
<!--           <img src="../assets/images/ling.png" alt="">-->
<!--           <span>我的消息</span>-->
<!--           <i v-if="userInfo.unread_message>0"></i>-->
<!--         </div>-->
         <div class="user-icon flex-items" >
           <div  v-if="token" class="flex-items" @click="goInfo">
             <img class="img" :src="userInfo.avatar" alt="">
             <span>{{ userInfo.nickname }}</span>
<!--             <div>超级管理员</div>-->
           </div>

           <span  v-if="token" class="logout" @click.stop="logOut">退出登录</span>
           <div class="kf-phone"><img src="../assets/images/nav/phone.png" alt=""> {{ baseInfo.custom_phone }}</div>
         </div>
<!--         <el-button v-else class="login" @click.stop="navTo('/login')">-->
<!--           注册/登录-->
<!--         </el-button>-->
       </div>
     </div>
   </div>
</template>

<script>
export default {
  name: "HeaderBar",
  computed:{
    token(){
      return this.$store.state.token
    },
    userInfo(){
      return this.$store.state.userInfo
    },
    baseInfo(){
      return this.$store.state.baseInfo
    }
  },
  mounted(){
   // this.getUserInfo()
    //this.getPhone()
  },
  methods:{
    getUserInfo(){
      if (this.token){
        this.$get('/api/user').then(res=>{
          this.setUserInfos(res.data)
        })
      }

    },
   getPhone(){
     this.$post('/api/index/config', {type:''}).then(res => {
       this.setConfig({phone:res.data.content})
     })
   },
    goInfo(){
      this.$router.push('/userInfo')
    },
    toIndex(){
      let route=this.$route.path;
      if (route!='/'){
        this.navTo("/")
      }
    },
    logOut(){
      this.$confirm('您确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '您已退出登录!'
        });
        localStorage.clear()
        this.navTo('/login')
        this.logOutStatus()
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped lang="scss">
   .header-bar{
     position: sticky;
     top: 0;
     left: 0;
     height:60px;
     background-color: #1565F7;
     color: #fff;
     z-index: 999;
     .header{
       width:1200px;
       height: 100%;
       display: flex;
       justify-content: space-between;
       align-items: center;
       margin: 0 auto;
       .logo{
          width: 158px;
         cursor: pointer;
       }
       .nav-btns{
         height: 100%;
         div{
           padding: 10px 20px;
           height: 100%;
           display: flex;
           align-items: center;
           border-bottom:2px solid transparent;
           cursor: pointer;
           &:hover{
            // color: #f82222;
           }
         }
         .active{
           border-bottom-color: #fff;
         }
       }
       .login-btns{
         display: flex;
         align-items: center;
         .msg{
           display: flex;
           align-items: center;
           height: 32px;
           border-radius: 22px;
           opacity: 1;
           border: 1px solid #E5E5E5;
           padding:0 16px 0 11px;
           position: relative;
           cursor: pointer;
           img{
             width:22px;
             height: 22px;
             margin-right: 3px
           }
           i{
             position: absolute;
             top:-2px;
             right: 2px;
             width: 10px;
             height: 10px;
             background: #F42323;
             border-radius: 50%;
           }
         }
         .user-icon{
           display: flex;
           align-items: center;
           margin-left: 30px;
           cursor: pointer;
           .img{
             width:40px;
             height: 40px;
             border-radius: 50%;
             margin-right: 12px;
             object-fit: cover;
           }
           .logout{
             margin-left: 19px;
             width: 76px;
             line-height: 25px;
             text-align: center;
             font-weight: 400;
             font-size: 12px;
             color: #333333;
             background: linear-gradient( 90deg, #E3F7FA 0%, #EBEBFF 100%);
             border-radius: 16px 16px 16px 16px;
             border-image: linear-gradient(180deg, rgba(181.65929943323135, 195.4106703400612, 255, 1), rgba(141.03982865810394, 199.9192652106285, 255, 1)) 1 1;

           }
           .kf-phone{
             margin-left: 34px;
             font-weight: 700;
             font-size: 18px;
             color: #FFFFFF;
             line-height: 17px;
             display: flex;
             align-items: center;
             img{
               width: 28px;
             }
           }
         }
         .login{
           background-color: #F42323;
           line-height: 32px;
           padding:0 16px;
           color: #ffffff;
           border-radius: 40px;
           font-size: 16px;
           font-weight: 400;
           margin-left: 30px
         }
       }

     }
   }
</style>
